// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/trip.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { TripService } from "./trip_pb";

/**
 * ListTrips returns every trip for an owner_key, newest first.
 *
 * @generated from rpc travplaces.v1.TripService.ListTrips
 */
export const listTrips = TripService.method.listTrips;

/**
 * GetTrip returns one trip by id (owner_key not checked, so a link opens).
 *
 * @generated from rpc travplaces.v1.TripService.GetTrip
 */
export const getTrip = TripService.method.getTrip;

/**
 * SaveTrip persists a planned trip and returns it whole.
 *
 * @generated from rpc travplaces.v1.TripService.SaveTrip
 */
export const saveTrip = TripService.method.saveTrip;

/**
 * UpdateTrip patches name/request/plan; unset fields are left as-is.
 *
 * @generated from rpc travplaces.v1.TripService.UpdateTrip
 */
export const updateTrip = TripService.method.updateTrip;

/**
 * DeleteTrip removes a trip owned by owner_key.
 *
 * @generated from rpc travplaces.v1.TripService.DeleteTrip
 */
export const deleteTrip = TripService.method.deleteTrip;

/**
 * PlanTrip plans a whole trip from a TripRequest JSON, returning a TripPlan.
 *
 * @generated from rpc travplaces.v1.TripService.PlanTrip
 */
export const planTrip = TripService.method.planTrip;

/**
 * PlanTripDay re-plans one day of a trip without disturbing the others.
 *
 * @generated from rpc travplaces.v1.TripService.PlanTripDay
 */
export const planTripDay = TripService.method.planTripDay;
